"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _activitySearchV = _interopRequireDefault(require("../partials-search-activity/activity-search-v2"));
var _WhyPeerspace = _interopRequireDefault(require("./WhyPeerspace"));
var _Testimonial = _interopRequireDefault(require("./Testimonial"));
var _BecomeAHost = _interopRequireDefault(require("./BecomeAHost"));
var _SpecialEvents = _interopRequireDefault(require("./SpecialEvents"));
var _HeroCarousel = _interopRequireDefault(require("../partials-hero-carousel/HeroCarousel"));
var _CityCarousel = _interopRequireDefault(require("./CityCarousel"));
var _Concierge = _interopRequireDefault(require("./Concierge"));
var _MobileDownload = _interopRequireDefault(require("./MobileDownload"));
var _SpaceCarousel = _interopRequireDefault(require("./SpaceCarousel"));
var _UseTypeCarousel = _interopRequireDefault(require("./UseTypeCarousel"));
var _Blog = _interopRequireDefault(require("./Blog"));
var _CovidHealthAndSafetyBanner = _interopRequireDefault(require("../shared-components/banners/CovidHealthAndSafetyBanner"));
var _helpers = require("../shared-components/helpers/helpers");
var _AppBanner = _interopRequireDefault(require("./AppBanner"));
var _sharedIntlProviderHOC = _interopRequireDefault(require("../shared-components/hocs/sharedIntlProviderHOC"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var HeroActivityGenders = [
// video shoot
{
  id: 'homepage_images/hero_images/Video_shoot.png?v=rb',
  activityGender: 'f'
},
// photo shoot
{
  id: 'homepage_images/hero_images/5-hero',
  activityGender: 'n'
},
// party
{
  id: 'homepage_images/hero_images/Party.png?v=rb',
  activityGender: 'f'
},
// meeting
{
  id: 'homepage_images/hero_images/1-hero',
  activityGender: 'n'
},
// workshop
{
  id: 'homepage_images/hero_images/Workshop_1.png?v=rb',
  activityGender: 'm'
},
// baby shower
{
  id: 'homepage_images/hero_images/6-hero',
  activityGender: 'f'
}];
var Homepage = /*#__PURE__*/function (_Component) {
  _inherits(Homepage, _Component);
  function Homepage(props) {
    var _this;
    _classCallCheck(this, Homepage);
    _this = _callSuper(this, Homepage, [props]);
    var trojanElement = null;
    var homepageData = null;
    _this.toggleBanner = _this.toggleBanner.bind(_assertThisInitialized(_this));
    if ('undefined' !== typeof document) {
      try {
        trojanElement = document.getElementById('initial-data');
        homepageData = JSON.parse(trojanElement.getAttribute('data-homepage'));
      } catch (err) {
        homepageData = {};
        console.warn(err);
      }
    } else {
      homepageData = _this.props;
    }
    var locale = (0, _lodash.get)(homepageData, 'locale', '');
    _this.state = _objectSpread(_objectSpread({}, homepageData), {}, {
      showCovidLinks: 'en-US' === locale,
      isClient: false,
      showAppBanner: false
    });
    return _this;
  }
  _createClass(Homepage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var wrapElement = document.getElementById('wrap');
      var navContainer = document.getElementById('nav-container');
      var didBannerClose = PSSessions.Cookies('PSAppBanner');
      this.setState({
        isClient: true
      });
      if (!_helpers.Helpers.isMobile(true)) {
        return this.setState({
          showAppBanner: false
        });
      }
      if (didBannerClose) {
        this.setState({
          showAppBanner: false
        });
      } else {
        this.setState({
          showAppBanner: true
        });
        setTimeout(function () {
          wrapElement.classList.add("app-banner");
          navContainer.classList.add("app-banner");
        }, 1000);
      }
    }
  }, {
    key: "toggleBanner",
    value: function toggleBanner() {
      var forceOff = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var didBannerClose = PSSessions.Cookies('PSAppBanner');
      var wrapElement = document.getElementById('wrap');
      var navContainer = document.getElementById('nav-container');
      if (!didBannerClose) {
        PSSessions.Cookies.set('PSAppBanner', true, Date.now() + 3888000000);
        this.setState({
          showAppBanner: false
        });
        wrapElement.classList.remove("app-banner");
        navContainer.classList.remove("app-banner");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        hero = _this$state.hero,
        searchFormProps = _this$state.searchFormProps,
        _this$state$activitie = _this$state.activities,
        activities = _this$state$activitie === void 0 ? {} : _this$state$activitie,
        _this$state$cities = _this$state.cities,
        cities = _this$state$cities === void 0 ? {} : _this$state$cities,
        _this$state$whyPeersp = _this$state.whyPeerspace,
        whyPeerspace = _this$state$whyPeersp === void 0 ? {} : _this$state$whyPeersp,
        _this$state$concierge = _this$state.concierge,
        concierge = _this$state$concierge === void 0 ? {} : _this$state$concierge,
        _this$state$specialEv = _this$state.specialEvents,
        specialEvents = _this$state$specialEv === void 0 ? {} : _this$state$specialEv,
        _this$state$spaces = _this$state.spaces,
        spaces = _this$state$spaces === void 0 ? {} : _this$state$spaces,
        _this$state$parties = _this$state.parties,
        parties = _this$state$parties === void 0 ? {} : _this$state$parties,
        _this$state$productio = _this$state.production,
        production = _this$state$productio === void 0 ? {} : _this$state$productio,
        _this$state$offsites = _this$state.offsites,
        offsites = _this$state$offsites === void 0 ? {} : _this$state$offsites,
        _this$state$events = _this$state.events,
        events = _this$state$events === void 0 ? {} : _this$state$events,
        _this$state$testimoni = _this$state.testimonial,
        testimonial = _this$state$testimoni === void 0 ? {} : _this$state$testimoni,
        _this$state$becomeAHo = _this$state.becomeAHost,
        becomeAHost = _this$state$becomeAHo === void 0 ? {} : _this$state$becomeAHo,
        _this$state$blog = _this$state.blog,
        blog = _this$state$blog === void 0 ? {} : _this$state$blog,
        _this$state$ios = _this$state.ios,
        ios = _this$state$ios === void 0 ? {} : _this$state$ios,
        isClient = _this$state.isClient,
        covidBanner = _this$state.covid_banner,
        showAppBanner = _this$state.showAppBanner,
        showCovidLinks = _this$state.showCovidLinks;
      var activeLocales = (0, _lodash.get)(this.props, 'envLocaleData', {});
      var urlLocale = (0, _lodash.get)(this.props, 'locale', '');
      var urlPrefix = (0, _lodash.get)(activeLocales, [urlLocale, 'url_prefix'], '') || _sharedIntlProviderHOC.default.getUrlPrefix();
      var heroArray = (0, _lodash.get)(hero, 'items', []);
      (0, _lodash.forEach)(heroArray, function (heroActivity) {
        var activity = (0, _lodash.find)(HeroActivityGenders, function (a) {
          return a.id === (0, _lodash.get)(heroActivity, 'contentCloudinaryId', '');
        });
        var activityGender = (0, _lodash.get)(activity, 'activityGender', 'n');
        (0, _lodash.assign)(heroActivity, {
          activityGender: activityGender
        });
      });
      return /*#__PURE__*/_react.default.createElement(_sharedIntlProviderHOC.default, this.props, /*#__PURE__*/_react.default.createElement("div", {
        className: "Homepage"
      }, showAppBanner && /*#__PURE__*/_react.default.createElement(_AppBanner.default, {
        toggleBanner: this.toggleBanner
      }), /*#__PURE__*/_react.default.createElement(_HeroCarousel.default, {
        searchFormProps: searchFormProps,
        heroData: hero,
        showCovidLink: showCovidLinks
      }), covidBanner && /*#__PURE__*/_react.default.createElement(_CovidHealthAndSafetyBanner.default, {
        showLink: showCovidLinks
      }), !(0, _lodash.isEmpty)(activities) && /*#__PURE__*/_react.default.createElement(_activitySearchV.default, {
        urlPrefix: urlPrefix,
        activities: activities
      }), !(0, _lodash.isEmpty)(whyPeerspace) && /*#__PURE__*/_react.default.createElement(_WhyPeerspace.default, whyPeerspace), !(0, _lodash.isEmpty)(cities) && /*#__PURE__*/_react.default.createElement(_CityCarousel.default, {
        urlPrefix: urlPrefix,
        cities: cities,
        isClient: isClient
      }), !(0, _lodash.isEmpty)(spaces) && /*#__PURE__*/_react.default.createElement(_SpaceCarousel.default, {
        urlPrefix: urlPrefix,
        spaces: spaces,
        isClient: isClient
      }), !(0, _lodash.isEmpty)(ios) && /*#__PURE__*/_react.default.createElement(_MobileDownload.default, ios), !(0, _lodash.isEmpty)(parties) && /*#__PURE__*/_react.default.createElement(_UseTypeCarousel.default, {
        urlPrefix: urlPrefix,
        isClient: isClient,
        content: parties,
        numberOfSlides: 3,
        mainClassName: "partiesSection"
      }), !(0, _lodash.isEmpty)(concierge) && /*#__PURE__*/_react.default.createElement(_Concierge.default, concierge), !(0, _lodash.isEmpty)(specialEvents) && /*#__PURE__*/_react.default.createElement(_SpecialEvents.default, specialEvents), !(0, _lodash.isEmpty)(production) && /*#__PURE__*/_react.default.createElement(_UseTypeCarousel.default, {
        urlPrefix: urlPrefix,
        isClient: isClient,
        content: production,
        numberOfSlides: 3,
        mainClassName: "productionSection"
      }), !(0, _lodash.isEmpty)(offsites) && /*#__PURE__*/_react.default.createElement(_UseTypeCarousel.default, {
        urlPrefix: urlPrefix,
        isClient: isClient,
        content: offsites,
        numberOfSlides: 3,
        mainClassName: "offsiteSection"
      }), !(0, _lodash.isEmpty)(events) && /*#__PURE__*/_react.default.createElement(_UseTypeCarousel.default, {
        urlPrefix: urlPrefix,
        isClient: isClient,
        content: events,
        numberOfSlides: 3,
        mainClassName: "eventsSection"
      }), !(0, _lodash.isEmpty)(blog) && /*#__PURE__*/_react.default.createElement(_Blog.default, _extends({}, blog, {
        isClient: isClient
      })), !(0, _lodash.isEmpty)(testimonial) && /*#__PURE__*/_react.default.createElement(_Testimonial.default, testimonial), !(0, _lodash.isEmpty)(becomeAHost) && /*#__PURE__*/_react.default.createElement(_BecomeAHost.default, becomeAHost)));
    }
  }]);
  return Homepage;
}(_react.Component);
exports.Homepage = Homepage;